import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';

export interface GetUserPermissionsParams {
  userId: string;
}

const getUserPermissions: QueryFunction<
  string[],
  ['/user/permission', GetUserPermissionsParams]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<string[]>(
    '/user/permission?' + new URLSearchParams({ ...queryKey[1] }).toString(),
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to fetch user permissions');
};

export default getUserPermissions;

const _mockData: string[] = ['add_checklist'];
